// HomePage.tsx
import { CallToAction } from "./components/CallToAction";
import { FeaturesGrid } from "./components/FeaturesGrid";
import { Footer } from "./components/Footer";
import { HeroSection } from "./components/HeroSection";
import { HowItWorks } from "./components/HowItWorks";
import { Navbar } from "./components/Navbar";
import { PricingSection } from "./components/PricingSection";
import { ProductShowcase } from "./components/ProductShowcase";
import { UseCases } from "./components/UseCases";

export function HomePage() {
  return (
    <main className="bg-white text-black">
      <Navbar />
      <HeroSection />
      {/* Add id attributes matching the navbar hrefs */}
      <div id="product">
        <ProductShowcase />
      </div>
      <div id="how-it-works">
        <HowItWorks />
      </div>
      <div id="features">
        <FeaturesGrid />
        <UseCases />
      </div>
      <div id="pricing">
        <PricingSection />
      </div>
      <div id="contact">
        <CallToAction />
        <Footer />
      </div>
    </main>
  );
}
